import React from 'react'
import { Spinner } from 'react-bootstrap'
import styles from './StatusCell.module.css'

const statusTypes = {
  active: { color: 'green', icon: '/assets/icons/circle-green.svg' },
  public: { color: 'green', icon: '/assets/icons/circle-green.svg' },
  error: { color: 'red', icon: '/assets/icons/circle-red.svg' },
  processing: { color: 'grey', icon: null },
  disabled: { color: 'red', icon: '/assets/icons/circle-red.svg' },
  danger: { color: 'red', icon: '/assets/icons/circle-red.svg' },
  online: { color: 'green', icon: '/assets/icons/circle-green.svg' },
  undefined: { color: 'green', icon: '/assets/icons/circle-green.svg' },
  archived: { color: 'grey', icon: '/assets/icons/archive-box.svg' },
  validated: { color: 'green', icon: '/assets/icons/circle-green.svg' },
  pending: { color: 'orange', icon: '/assets/icons/circle-orange.svg' },
  initiated: { color: 'blue', icon: '/assets/icons/circle-blue.svg' },
  failed: { color: 'red', icon: '/assets/icons/circle-red.svg' },
  preview: { color: 'grey', icon: '/assets/icons/circle-grey.svg' },
  incomplete: { color: 'yellow', icon: '/assets/icons/circle-orange.svg' }
}

const StatusIcon = ({ status }) => {
  const statusInfo = statusTypes[status] || statusTypes.active

  if (status === 'processing') {
    return (
      <div className="d-flex">
        <Spinner className={styles.processingSpinner} animation="grow" variant="secondary" size="sm" />
      </div>
    )
  }

  return statusInfo.icon ? <img src={statusInfo.icon} height="10px" alt={status} /> : null
}

const StatusCell = ({ status, text, passwordProtected, emailProtected, ssoProtected, className }) => {
  const statusInfo = statusTypes[status] || statusTypes.active

  if (passwordProtected || emailProtected || ssoProtected) {
    return (
      <div className={styles.container}>
        <div className={`${styles.statusBadge} ${styles.private}`}>
          <div className={`${styles.statusBullet} ${styles.privateBullet}`}></div>
          <span className={`${styles.statusText} ${className || ''}`} data-testid="StatusCell-span-status-text">
            Private
          </span>
        </div>
      </div>
    )
  }

  if (text === 'Archived' || status === 'archived') {
    return (
      <div className={styles.container}>
        <div className={`${styles.statusBadge} ${styles.archived}`}>
          <div className={`${styles.statusBullet} ${styles.archivedBullet}`}></div>
          <span className={`${styles.statusText} ${className || ''}`} data-testid="StatusCell-span-status-text">
            Archived
          </span>
        </div>
      </div>
    )
  }

  if (text === 'Deleted' || status === 'deleted') {
    return (
      <div className={styles.container}>
        <div className={`${styles.statusBadge} ${styles.red}`}>
          <div className={`${styles.statusBullet} ${styles.redBullet}`}></div>
          <span className={`${styles.statusText} ${className || ''}`} data-testid="StatusCell-span-status-text">
            Deleted
          </span>
        </div>
      </div>
    )
  }

  if (text === 'Public' || status === 'online' || status === 'active') {
    return (
      <div className={styles.container}>
        <div className={`${styles.statusBadge} ${styles.public}`}>
          <div className={`${styles.statusBullet} ${styles.publicBullet}`}></div>
          <span className={`${styles.statusText} ${className || ''}`} data-testid="StatusCell-span-status-text">
            Public
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={`${styles.statusBadge} ${styles[statusInfo.color]}`}>
        <StatusIcon status={status} />
        <span className={`${styles.statusText} ${className || ''}`} data-testid="StatusCell-span-status-text">
          {text}
        </span>
      </div>
    </div>
  )
}

export default StatusCell
